const LOG_ENDPOINT = `${import.meta.env.VITE_API_BASE_URL}/${import.meta.env.VITE_API_PREFIX}/logs`;
const ENABLE_FILE_LOG = import.meta.env.VITE_LOG_TO_FILE === 'true';

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const queue: { level: LogLevel; message: string; timestamp: string }[] = [];
let flushTimer: ReturnType<typeof setTimeout> | null = null;

function flush() {
  if (queue.length === 0) return;
  const batch = queue.splice(0);
  navigator.sendBeacon(LOG_ENDPOINT, JSON.stringify(batch));
}

function enqueue(level: LogLevel, args: unknown[]) {
  const message = args.map(a => (typeof a === 'string' ? a : JSON.stringify(a))).join(' ');

  if (ENABLE_FILE_LOG) {
    queue.push({ level, message, timestamp: new Date().toISOString() });
    if (!flushTimer) {
      flushTimer = setTimeout(() => {
        flushTimer = null;
        flush();
      }, 2000);
    }
  }
}

const logger = {
  debug: (...args: unknown[]) => { console.debug(...args); enqueue('debug', args); },
  info: (...args: unknown[]) => { console.log(...args); enqueue('info', args); },
  warn: (...args: unknown[]) => { console.warn(...args); enqueue('warn', args); },
  error: (...args: unknown[]) => { console.error(...args); enqueue('error', args); },
};

// Flush remaining logs before page unload
if (ENABLE_FILE_LOG) {
  window.addEventListener('beforeunload', flush);
}

export default logger;
